if (!window.customElements.get('ingredients-proof-accordion')) {
  window.customElements.define(
    'ingredients-proof-accordion',
    class IngredientsProofAccordion extends window.HTMLElement {
      connectedCallback() {
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.singleOpen = this.dataset.singleOpen === 'true';
        this.addEventListener('click', this.handleToggleClick);
        this.syncInitialState();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleToggleClick);
      }

      syncInitialState() {
        let hasOpenItem = false;

        this.querySelectorAll('.ingredients-proof__item').forEach((item) => {
          let isOpen = item.classList.contains('is-open');

          if (this.singleOpen && isOpen) {
            if (hasOpenItem) {
              isOpen = false;
            } else {
              hasOpenItem = true;
            }
          }

          this.setExpanded(item, isOpen);
        });
      }

      handleToggleClick(event) {
        const toggle = event.target.closest('.ingredients-proof__toggle');
        if (!toggle || !this.contains(toggle)) return;

        const item = toggle.closest('.ingredients-proof__item');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');

        if (this.singleOpen && willOpen) {
          this.querySelectorAll('.ingredients-proof__item.is-open').forEach((openItem) => {
            if (openItem !== item) this.setExpanded(openItem, false);
          });
        }

        this.setExpanded(item, willOpen);
        this.dispatchEvent(new CustomEvent('accordion-change', { bubbles: true }));
      }

      setExpanded(item, expanded) {
        const toggle = item.querySelector('.ingredients-proof__toggle');
        const panel = item.querySelector('.ingredients-proof__panel');

        item.classList.toggle('is-open', expanded);

        if (toggle) {
          toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }

        if (panel) {
          panel.setAttribute('aria-hidden', expanded ? 'false' : 'true');
        }
      }

      getItems() {
        return Array.from(this.querySelectorAll('.ingredients-proof__item'));
      }

      areAllExpanded() {
        const items = this.getItems();
        return items.length > 0 && items.every((item) => item.classList.contains('is-open'));
      }

      expandAll() {
        this.getItems().forEach((item) => this.setExpanded(item, true));
        this.dispatchEvent(new CustomEvent('accordion-change', { bubbles: true }));
      }

      collapseAll() {
        this.getItems().forEach((item) => this.setExpanded(item, false));
        this.dispatchEvent(new CustomEvent('accordion-change', { bubbles: true }));
      }
    },
  );
}
